import React from 'react';

import PropTypes from 'prop-types';

import { Container, Inner } from './styles';

export const FixedBottomPanel = (props) => {
    return (
        <Container
            isPressedAboveMenu={props.isPressedAboveMenu}
            forSpinner={props.forSpinner}
            fullwidth={props.fullwidth}
            buttonPosition={props.buttonPosition}
            isNewMainScreen={props.isNewMainScreen}
            insideStories={props.insideStories}
        >
            <Inner
                isRightAligned={props.isRightAligned}
                fullwidth={props.fullwidth}
                isKeyboardOpened={props.isKeyboardOpened}
                isNewMainScreen={props.isNewMainScreen}
            >
                {props.children}
            </Inner>
        </Container>
    );
};

FixedBottomPanel.propTypes = {
    isPressedAboveMenu: PropTypes.bool,
    forSpinner: PropTypes.bool,
    isRightAligned: PropTypes.bool,
    fullwidth: PropTypes.bool,
    isNewMainScreen: PropTypes.bool,
    insideStories: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};
